<style>
    /* z uwagi na mix angularJS i nowego ng pobieranie assetów na ten moment musi zostać tutaj 
możliwe że kiedyś się to ogarnie w inny sposób */
    .multi-day-route {
        min-width: 0;
        height: 16px;
        background-image: url('./img/planner/multi_day_route_start.png');
        background-repeat: no-repeat;
    }

    .multi-day-route--following-days {
        background-image: url('./img/planner/multi_day_route.png');
    }
</style>
<div class="routes-main-box flexContent flexColumn gap-8" (dragenter)="onDragMainEnter($event)"
    (dragover)="onDragMainOver($event)" (dragleave)="onDragMainLeave($event)"
    (drop)="resetDragProps()"
    [class.routes-main-box--is-invalid]="day.isInvalid">

    <ng-container *ngIf="day.absences">
        <absence-day-box [absences]="day.absences!" [driver]="driver"
            (addNewAbsence)="addNewAbsence.emit($event)"></absence-day-box>
    </ng-container>

    <div class="route-box" *ngFor="let route of routes; "
        [class.routes-main-box--drag-available]="isValidDragOver && (route.IsPhantomRoute || route.IsRouteAsDriverAsistant)"
        [class.routes-main-box--drag-over]="(idOfRouteTheDragIsOver === route.routeId) && !dragRegionNotValid"
        [class.routes-main-box--drag-not-valid]="dragRegionNotValid"
        [class.route-box--drag-not-valid]="dragRegionNotValid"
        [class.route-box--is-phantom-route]="route.IsPhantomRoute"
        [class.route-box--is-route-as-assistant-driver]="route.IsRouteAsDriverAsistant"
        (dragenter)="onDragOnRouteEnter($event, route)" (dragover)="onDragOnRouteOver($event, route)"
        (dragleave)="onDragOnRouteLeave()" (drop)="onDrop($event, route)">

        <div *ngFor="let order of route.orders; let last = last; let first = first; let index = index"
            [class.routes-main-box--dim-content]="isValidDragOver" [class.pointer-events-none]="isValidDragOver">

            <div *ngIf="!first && route.orders.length > 1" class="routes-main-box__divider">
            </div>
            <order-box [order]="order" [isEmbeddedInRoute]="true" [class.pointer-events-none]="isValidDragOver"
                [route]="route" [day]="day" [driver]="driver" [showStatusSection]="true"
                (editRoute)="editRoute.emit($event)"
                (editShipment)="editShipment.emit({ shipment: $event, route: route})"
                (showConflicts)="showConflicts.emit($event)" (sendRouteToDriver)="sendRouteToDriver.emit($event)"
                [isInPhantomRoute]="route.IsPhantomRoute || route.IsRouteAsDriverAsistant"
                (addNewAbsence)="addNewAbsence.emit($event)"></order-box>
        </div>

        <div *ngIf="route.IsMultiDayRoute" class="multi-day-route"
            [class.multi-day-route--following-days]="route.IsOneOfFallowingDaysOfMultiDayRoute">
        </div>
    </div>
    <div *ngIf="isValidDragOver && newRoutePossible"
        class="routes-main-box--drag-available flex-grow flexContent justify-center align-center layout-mt-6"
        [class.routes-main-box--drag-over]="isDragOverNewRoute" (dragenter)="onDragOnNewRouteEnter($event)"
        (dragover)="onDragOnNewRouteOver($event)" (dragleave)="onDragOnNewRouteLeave($event)" (drop)="onDrop($event)">
        <div class="pointer-events-none layout-py-10">Nowa trasa</div>
    </div>
</div>